function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.997 511.997",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#0F7986"
    },
    cx: 255.999,
    cy: 255.999,
    r: 255.999
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#076673"
    },
    cx: 255.999,
    cy: 421.644,
    rx: 182.283,
    ry: 14.369
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M65.982,67.222h380.036c12.486,0,22.7,10.217,22.7,22.703V324.03H43.282V89.925 C43.282,77.439,53.496,67.222,65.982,67.222z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M58.695,308.614h394.607V89.922c0-3.979-3.308-7.287-7.287-7.287H65.979 c-3.976,0-7.287,3.308-7.287,7.287v218.693H58.695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M468.718,324.03v24.826c0,12.489-11.261,22.703-25.026,22.703H68.305 c-13.765,0-25.026-10.214-25.026-22.703V324.03h425.436H468.718z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 170.057,
    y: 95.673,
    style: {
      fill: "#ECF0F1"
    },
    width: 271.129,
    height: 23.185
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.556,
    y: 136.742,
    style: {
      fill: "#ECF0F1"
    },
    width: 316.37,
    height: 43.45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.556,
    y: 193.281,
    style: {
      fill: "#ECF0F1"
    },
    width: 316.37,
    height: 43.45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.556,
    y: 249.831,
    style: {
      fill: "#ECF0F1"
    },
    width: 316.37,
    height: 43.45
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5B62"
    },
    d: "M81.229,97.054c-0.113,0.2-0.234,0.341-0.359,0.43c-0.129,0.092-0.288,0.137-0.477,0.137 c-0.197,0-0.409-0.076-0.643-0.221c-0.234-0.147-0.511-0.306-0.831-0.485c-0.322-0.181-0.695-0.346-1.125-0.493 c-0.43-0.147-0.942-0.216-1.527-0.216c-0.53,0-0.994,0.06-1.39,0.189c-0.396,0.129-0.73,0.306-0.997,0.535 c-0.27,0.229-0.475,0.496-0.606,0.813c-0.131,0.317-0.197,0.667-0.197,1.044c0,0.483,0.137,0.884,0.406,1.207 c0.267,0.32,0.622,0.596,1.068,0.823c0.443,0.226,0.949,0.43,1.519,0.609c0.567,0.179,1.149,0.367,1.745,0.572 c0.596,0.202,1.178,0.441,1.745,0.711c0.567,0.27,1.073,0.609,1.519,1.02c0.443,0.412,0.802,0.918,1.073,1.513 c0.267,0.596,0.401,1.316,0.401,2.169c0,0.926-0.158,1.791-0.472,2.599c-0.317,0.807-0.779,1.513-1.39,2.114 c-0.609,0.601-1.356,1.073-2.235,1.419c-0.878,0.346-1.886,0.522-3.022,0.522c-0.653,0-1.295-0.068-1.93-0.194 c-0.632-0.129-1.238-0.306-1.82-0.543c-0.582-0.237-1.131-0.522-1.64-0.852c-0.511-0.33-0.965-0.698-1.361-1.107l1.12-1.828 c0.095-0.134,0.218-0.247,0.37-0.335c0.152-0.089,0.312-0.131,0.483-0.131c0.237,0,0.49,0.095,0.766,0.288 c0.275,0.194,0.601,0.409,0.978,0.648c0.38,0.237,0.823,0.448,1.329,0.643s1.11,0.293,1.82,0.293c1.086,0,1.93-0.259,2.526-0.776 c0.596-0.514,0.894-1.254,0.894-2.217c0-0.538-0.131-0.978-0.401-1.319c-0.267-0.341-0.63-0.63-1.073-0.86 c-0.443-0.234-0.952-0.425-1.519-0.588c-0.567-0.16-1.144-0.335-1.732-0.525c-0.585-0.189-1.162-0.417-1.732-0.68 c-0.567-0.264-1.073-0.611-1.516-1.036c-0.446-0.425-0.8-0.96-1.07-1.6c-0.27-0.638-0.406-1.421-0.406-2.358 c0-0.748,0.152-1.474,0.448-2.185c0.299-0.711,0.73-1.34,1.295-1.886c0.567-0.548,1.267-0.989,2.099-1.319 c0.832-0.33,1.786-0.496,2.864-0.496c1.212,0,2.329,0.189,3.347,0.567c1.023,0.377,1.891,0.907,2.61,1.59l-0.949,1.802 L81.229,97.054z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBB429"
    },
    d: "M94.646,104.884c0-0.454-0.06-0.884-0.189-1.287c-0.129-0.401-0.322-0.751-0.577-1.055 c-0.257-0.301-0.577-0.543-0.968-0.719c-0.393-0.176-0.852-0.259-1.372-0.259c-1.012,0-1.804,0.288-2.387,0.865 c-0.58,0.577-0.955,1.393-1.118,2.452h6.61v0.003H94.646z M87.965,106.995c0.058,0.748,0.189,1.39,0.396,1.936 c0.21,0.543,0.483,0.991,0.823,1.348c0.338,0.354,0.745,0.619,1.215,0.792c0.469,0.176,0.984,0.264,1.55,0.264 c0.566,0,1.06-0.066,1.471-0.197c0.409-0.134,0.771-0.28,1.078-0.441c0.306-0.16,0.577-0.306,0.807-0.441 c0.234-0.131,0.454-0.197,0.672-0.197c0.291,0,0.511,0.11,0.653,0.325l1.005,1.277c-0.385,0.454-0.823,0.831-1.303,1.139 c-0.48,0.309-0.984,0.554-1.508,0.738c-0.525,0.187-1.06,0.317-1.603,0.393c-0.543,0.076-1.073,0.113-1.584,0.113 c-1.012,0-1.954-0.171-2.822-0.506c-0.871-0.335-1.626-0.831-2.269-1.49c-0.643-0.659-1.152-1.471-1.519-2.439 c-0.37-0.97-0.554-2.091-0.554-3.365c0-0.991,0.16-1.93,0.483-2.804c0.322-0.873,0.786-1.637,1.385-2.285 c0.601-0.648,1.332-1.157,2.198-1.537c0.865-0.377,1.838-0.567,2.924-0.567c0.92,0,1.766,0.147,2.539,0.441 c0.776,0.293,1.442,0.719,2.001,1.28c0.559,0.564,0.997,1.254,1.314,2.072c0.314,0.818,0.472,1.755,0.472,2.804 c0,0.53-0.058,0.884-0.171,1.07c-0.116,0.184-0.33,0.278-0.653,0.278h-9.007L87.965,106.995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21D0C3"
    },
    d: "M108.107,107.622c-1.012,0.047-1.862,0.134-2.552,0.259c-0.69,0.129-1.244,0.291-1.661,0.49 c-0.417,0.197-0.714,0.43-0.894,0.695c-0.179,0.264-0.27,0.554-0.27,0.865c0,0.614,0.187,1.055,0.548,1.316 c0.364,0.267,0.836,0.396,1.421,0.396c0.719,0,1.343-0.131,1.867-0.391c0.524-0.26,1.036-0.653,1.537-1.181v-2.455L108.107,107.622z  M100.078,101.311c1.674-1.532,3.688-2.298,6.043-2.298c0.85,0,1.613,0.137,2.282,0.417c0.674,0.278,1.238,0.667,1.703,1.165 c0.464,0.496,0.818,1.091,1.06,1.782s0.362,1.448,0.362,2.272v9.191h-1.59c-0.33,0-0.585-0.053-0.766-0.152 c-0.179-0.1-0.322-0.296-0.425-0.601l-0.312-1.049c-0.37,0.333-0.73,0.622-1.078,0.871c-0.351,0.252-0.716,0.464-1.094,0.632 c-0.377,0.171-0.779,0.299-1.212,0.388c-0.43,0.089-0.907,0.137-1.429,0.137c-0.614,0-1.181-0.084-1.7-0.252 c-0.522-0.166-0.97-0.412-1.348-0.743c-0.38-0.33-0.674-0.745-0.881-1.236c-0.21-0.49-0.312-1.062-0.312-1.716 c0-0.37,0.06-0.738,0.187-1.102c0.124-0.364,0.325-0.711,0.606-1.041c0.28-0.33,0.638-0.643,1.083-0.936 c0.443-0.291,0.991-0.548,1.64-0.765c0.648-0.218,1.4-0.396,2.261-0.535c0.86-0.137,1.844-0.218,2.951-0.247v-0.85 c0-0.976-0.208-1.7-0.624-2.167s-1.018-0.698-1.802-0.698c-0.567,0-1.036,0.066-1.408,0.197c-0.372,0.134-0.703,0.28-0.989,0.443 c-0.283,0.166-0.538,0.317-0.771,0.448c-0.231,0.131-0.49,0.2-0.773,0.2c-0.244,0-0.454-0.068-0.624-0.194 c-0.171-0.129-0.306-0.272-0.409-0.443l-0.624-1.123L100.078,101.311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5B62"
    },
    d: "M118.122,101.807c0.454-0.871,0.991-1.555,1.619-2.051c0.624-0.498,1.361-0.743,2.214-0.743 c0.672,0,1.212,0.147,1.619,0.441l-0.229,2.626c-0.047,0.171-0.113,0.288-0.202,0.359c-0.092,0.071-0.213,0.108-0.364,0.108 c-0.142,0-0.349-0.024-0.63-0.071s-0.554-0.071-0.818-0.071c-0.385,0-0.732,0.058-1.036,0.171c-0.301,0.116-0.572,0.275-0.813,0.488 c-0.242,0.213-0.454,0.472-0.638,0.773c-0.187,0.301-0.362,0.648-0.519,1.036v8.965h-3.504V99.286h2.056 c0.359,0,0.611,0.06,0.753,0.189c0.142,0.129,0.237,0.359,0.283,0.69l0.213,1.645L118.122,101.807z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBB429"
    },
    d: "M135.413,102.36c-0.105,0.131-0.205,0.237-0.301,0.312c-0.1,0.076-0.247,0.113-0.435,0.113 c-0.179,0-0.354-0.055-0.525-0.163c-0.171-0.11-0.372-0.234-0.611-0.37c-0.237-0.137-0.514-0.259-0.839-0.367 c-0.325-0.108-0.735-0.16-1.215-0.16c-0.617,0-1.154,0.108-1.619,0.33c-0.464,0.223-0.847,0.543-1.154,0.96 c-0.306,0.417-0.538,0.918-0.69,1.508c-0.152,0.593-0.226,1.262-0.226,2.009c0,0.776,0.084,1.466,0.25,2.07 c0.166,0.606,0.401,1.112,0.714,1.524s0.69,0.722,1.136,0.936c0.443,0.213,0.944,0.32,1.503,0.32c0.556,0,1.012-0.071,1.356-0.208 c0.344-0.137,0.632-0.288,0.868-0.454c0.237-0.166,0.446-0.314,0.619-0.454c0.176-0.137,0.37-0.205,0.588-0.205 c0.283,0,0.496,0.11,0.638,0.325l1.007,1.277c-0.388,0.454-0.81,0.831-1.262,1.139c-0.454,0.309-0.923,0.554-1.408,0.738 c-0.488,0.187-0.989,0.317-1.506,0.393c-0.514,0.076-1.028,0.113-1.54,0.113c-0.897,0-1.747-0.171-2.539-0.506 c-0.794-0.335-1.49-0.823-2.085-1.466c-0.596-0.64-1.065-1.432-1.408-2.363s-0.519-1.991-0.519-3.182 c0-1.07,0.158-2.062,0.464-2.974c0.306-0.91,0.756-1.703,1.35-2.368c0.598-0.667,1.335-1.186,2.214-1.566 c0.878-0.377,1.891-0.567,3.037-0.567c1.086,0,2.043,0.176,2.859,0.525c0.818,0.349,1.55,0.852,2.204,1.503l-0.92,1.277 L135.413,102.36L135.413,102.36z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21D0C3"
    },
    d: "M142.164,100.841c0.567-0.53,1.191-0.96,1.872-1.29c0.682-0.33,1.479-0.496,2.397-0.496 c0.794,0,1.5,0.134,2.114,0.401c0.614,0.267,1.131,0.648,1.54,1.136c0.412,0.488,0.724,1.07,0.936,1.745 c0.213,0.677,0.314,1.424,0.314,2.238v9.262h-3.504v-9.262c0-0.889-0.202-1.579-0.609-2.067c-0.406-0.488-1.026-0.727-1.857-0.727 c-0.606,0-1.175,0.137-1.703,0.409c-0.53,0.275-1.031,0.648-1.503,1.12v10.526h-3.504V92.757h3.504v8.084H142.164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21D0C3"
    },
    d: "M425.999,116.23l-4.308-5.447c-0.781,0.328-1.64,0.509-2.539,0.509 c-1.804,0-3.446-0.735-4.635-1.922h-0.008c-1.186-1.186-1.922-2.83-1.922-4.643c0-1.804,0.735-3.446,1.922-4.635l0.008-0.008 c1.189-1.186,2.83-1.922,4.635-1.922c1.812,0,3.457,0.735,4.643,1.922v0.008c1.186,1.189,1.922,2.83,1.922,4.635 c0,1.448-0.469,2.786-1.262,3.871l4.307,5.445l-2.762,2.183L425.999,116.23z M421.299,102.586l-0.003,0.003 c-0.548-0.548-1.303-0.886-2.141-0.886c-0.836,0-1.595,0.338-2.141,0.878l-0.008,0.008c-0.543,0.548-0.878,1.303-0.878,2.141 c0,0.836,0.338,1.595,0.886,2.141l-0.003,0.003c0.548,0.546,1.306,0.884,2.143,0.884c0.836,0,1.595-0.338,2.141-0.886 c0.548-0.548,0.886-1.303,0.886-2.141C422.183,103.891,421.845,103.131,421.299,102.586z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 83.437,
    y: 144.567,
    style: {
      fill: "#FF5B62"
    },
    width: 56.38,
    height: 4.208
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.437,
    y: 154.288,
    style: {
      fill: "#21D0C3"
    },
    width: 39.223,
    height: 3.984
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C0C1C4"
    },
    d: "M83.438,162.49h190.884v3.135H83.438V162.49z M83.438,171.305h151.357v3.135H83.438V171.305z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.437,
    y: 201.885,
    style: {
      fill: "#FF5B62"
    },
    width: 56.38,
    height: 4.208
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.437,
    y: 211.595,
    style: {
      fill: "#21D0C3"
    },
    width: 39.223,
    height: 3.984
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C0C1C4"
    },
    d: "M83.438,219.797h190.884v3.135H83.438V219.797z M83.438,228.613h151.357v3.135H83.438V228.613z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.437,
    y: 259.182,
    style: {
      fill: "#FF5B62"
    },
    width: 56.38,
    height: 4.208
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.437,
    y: 268.903,
    style: {
      fill: "#21D0C3"
    },
    width: 39.223,
    height: 3.984
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C0C1C4"
    },
    d: "M83.438,277.104h190.884v3.135H83.438V277.104z M83.438,285.921h151.357v3.135H83.438V285.921z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#B6B6B8"
    },
    cx: 255.999,
    cy: 346.801,
    r: 7.814
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C2C2C4"
    },
    d: "M305.065,407.271l36.095,11.564H170.836l29.123-11.564v-35.712h105.104v35.712H305.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6B6B8"
    },
    d: "M305.065,407.271l-105.104-35.712h105.104V407.271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M199.959,407.271h105.104l36.095,11.564v4.981h-85.161h-85.163v-4.981l29.123-11.564H199.959z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearch);
export default __webpack_public_path__ + "static/media/research.701d9445d41d6d07a8bf4c73adf617a2.svg";
export { ForwardRef as ReactComponent };